// extracted by mini-css-extract-plugin
export default {"title":"delete_title__Ea5K5","buttonPart":"delete_buttonPart__i1BLE","buttonCancel":"delete_buttonCancel__-Q+gy","buttonDelete":"delete_buttonDelete__Yee4q"};